import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BookUploadContext } from './context';

const Span = styled.span`
	color: var(--shade-shade-60, #727780);
	font-family: Public Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px; /* 171.429% */
	margin-left: 15px;
`
class InputTopic extends React.Component {
	static propTypes = {
		width: PropTypes.string.isRequired,
		placeholder: PropTypes.string.isRequired,
		spanText: PropTypes.string,
		titulo: PropTypes.string,
		field: PropTypes.string,
		topicId: PropTypes.string,
		chapterId: PropTypes.string,
		data: PropTypes.any
	};

	static contextType = BookUploadContext;

	render() {
		const {
			width,
			placeholder,
			spanText,
			field,
			chapterId,
			topicId,
		} = this.props;
		const { data, updateTopic } = this.context;

		return (
			<div>
				<Span>{spanText}</Span>
				<input
					style={{ width: `${width}` }}
					type="text"
					className="form-control"
					placeholder={placeholder}
					onChange={(((e) => updateTopic(parseInt(chapterId), topicId, field, e.target.value)))}
					value={data[chapterId]["topic"][topicId][field]}
				/>
			</div>
		);
	}
}

export default InputTopic;
